import { useQuery } from 'react-query';
import CollectionsAPI from 'services/API/CollectionsAPI';
import type { ProjectSharedListPresence } from 'types';

type SharedPresenceResponse = {
  data: ProjectSharedListPresence[];
  message: string;
};

export const useProjectSharedListsOnPdp = (projectSlug: string | undefined) => {
  return useQuery(
    ['project-shared-lists', projectSlug],
    async (): Promise<ProjectSharedListPresence[]> => {
      const result = await CollectionsAPI.getSharedPresence(projectSlug!);

      return (result?.data as SharedPresenceResponse)?.data ?? [];
    },
    {
      enabled: Boolean(projectSlug),
      refetchOnWindowFocus: false,
    },
  );
};
